<template>
  <div class="search-page">
    <div class="tabs-bar">
      <div class="bar-wrap">
        <div :class="['tab', active === 0 ? 'active' : '']" @click="active = 0">
          作品
        </div>
        <div :class="['tab', active === 1 ? 'active' : '']" @click="active = 1">
          学生
        </div>
      </div>
    </div>
    <div class="search-box">
      <div class="search-wrap">
        <img src="../../assets/images/home/search-ico.png" alt="" />
        <input
          type="text"
          v-model="searchStr"
          @keyup.enter="search"
          placeholder="输入作品名、作品编号、学生名"
        />
      </div>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      v-if="active === 0"
    >
      <div class="works-list">
        <div
          class="works-item"
          v-for="(item, i) in dataList"
          :key="i"
          @click="toPhotoDetail(item)"
        >
          <div class="works-img">
            <img v-setshow :src="item.img" alt="" />
          </div>
          <div class="works-infos">
            <div class="works-tit">
              <div class="tit-infos">
                <div class="works-title">{{ item.title }}</div>
                <div
                  class="slogan"
                  @click.stop="(showSlogan = true), (content = item.slogan)"
                >
                  <div>{{ item.slogan }}</div>
                </div>
              </div>
            </div>
            <div class="author-info">
              <div class="author">
                <p>
                  {{ `${item.author} | ${item.majorName} | ${item.groupName}` }}
                </p>
                <p>报名服务单位：{{ item.organization }}</p>
                <p>上传：{{ item.time }}</p>
              </div>
              <!-- <div class="remark-area">
                <div
                  class="btn"
                  @click="
                    $router.push({
                      path: '/judge/remarkpage',
                      query: { id: item.id, isRemark: 0 }
                    })
                  "
                >
                  评价
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <van-list
      v-model="sloading"
      :finished="sfinished"
      finished-text="没有更多了"
      @load="sonLoad"
      v-if="active === 1"
    >
      <div class="student-list" v-for="(item, i) in sdataList" :key="i">
        <div class="student-item">
          <img v-if="item.head" :src="item.head" alt="" />
          <img
            v-else
            :src="require('../../assets/images/home/unuser_head.svg')"
            alt=""
          />
          <div class="infos">
            <div>{{ item.name }}</div>
            <p>
              {{
                `${item.sex == 1 ? "男" : item.sex == 2 ? "女" : ""} ${
                  item.age
                }岁 ${item.teacherName}`
              }}
            </p>
          </div>
          <div class="school">{{ item.schoolName }}</div>
        </div>
      </div>
    </van-list>
    <!-- 简介信息 -->
    <van-popup
      v-model="showSlogan"
      class="slogan"
      closeable
      close-icon="arrow-down"
      close-icon-position="top-right"
      position="bottom"
      :style="{ height: '50%' }"
    >
      <div class="info-wrap">
        <div class="intro" v-html="content"></div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { getHomePageInstitutionWorks, getPageUserBaby } from "@/utils/api/org";
export default {
  data() {
    return {
      // 0作品，1学生
      active: 0,
      // 搜索 字符串
      searchStr: "",
      // 作品列表
      dataList: "",
      // 学生列表
      sdataList: "",

      loading: false,
      finished: false,
      page: 0,
      pageSize: 10,

      sloading: false,
      sfinished: false,
      spage: 0,
      spageSize: 10,
      showSlogan: false,
      content: ""
    };
  },
  watch: {
    active: function (v) {
      if (v) {
        this.dataList = [];
        this.page = 0;
        this.loading = false;
        this.finished = false;
      } else {
        this.sdataList = [];
        this.spage = 0;
        this.sloading = false;
        this.sfinished = false;
      }
      this.searchStr = "";
    }
  },
  methods: {
    // 详情
    toPhotoDetail(item) {
      this.$root.mipLink("/player/photodetail", { id: item.id });
      // this.$router.push({
      //   path: "/player/photodetail",
      //   query: {
      //     id: item.id
      //   }
      // });
    },
    // 加载
    onLoad() {
      this.page++;
      this.getWoks(this.page === 1);
    },
    // 搜索
    search() {
      this.page = 0;
      this.spage = 0;
      if (!this.active) {
        this.page++;
        this.getWoks(this.page === 1);
      } else {
        this.spage++;
        this.getStudents(this.spage === 1);
      }
    },
    // 获取作品
    getWoks(init = false) {
      this.loading = true;
      if (init) this.dataList = [];
      const p = {
        pageNo: this.page,
        pageSize: this.pageSize,
        name: this.searchStr
      };
      if (!this.searchStr) {
        delete p.name;
      }
      getHomePageInstitutionWorks(p).then((res) => {
        if (res.success) {
          const loadData = res.data.records.map((e) => {
            return {
              id: e.id,
              img: e.imgs,
              title: e.name,
              author: e.babyName,
              organization: e.institutionName || "暂无报名服务单位",
              time: e.addTime,
              majorName: e.majorName,
              groupName: e.groupName,
              slogan: e.synopsis
            };
          });
          this.dataList.push(...loadData);
        } else {
          this.finished = true;
          this.loading = false;
        }
        this.loading = false;
        if (this.page * this.pageSize >= res.data.total) {
          this.finished = true;
        }
      });
    },
    sonLoad() {
      this.spage++;
      this.getStudents(this.spage === 1);
    },
    // 获取学员
    getStudents(init = false) {
      this.sloading = true;
      if (init) this.sdataList = [];
      const p = {
        pageNo: this.spage,
        pageSize: this.spageSize,
        name: this.searchStr
      };
      getPageUserBaby(p).then((res) => {
        if (res.success) {
          const loadData = res.data.records.map((e) => {
            return {
              sex: e.sex,
              name: e.name,
              head: e.imgUrl,
              age: e.age,
              teacherName: e.teacherName,
              schoolName: e.schoolName
            };
          });
          this.sdataList.push(...loadData);
        } else {
          this.sfinished = true;
          this.sloading = false;
        }
        this.sloading = false;
        if (this.spage * this.spageSize >= res.data.total) {
          this.sfinished = true;
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.search-page {
  text-align: left;
  .tabs-bar {
    position: fixed;
    top: 0;
    left: 0px;
    width: 375px;
    height: 52px;
    border-bottom: 1px solid #f2f2f2;
    background: #ffffff;
    box-shadow: 0px 3px 5px rgba(108, 221, 143, 0.26);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    z-index: 20;
    .bar-wrap {
      width: 100%;
      height: 30px;
      border-radius: 15px;
      display: flex;
      overflow: hidden;
      .tab {
        width: 50%;
        font-size: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        color: #054b1b33;
        font-weight: bold;
        &.active {
          // background-color: #16d77a;
          color: #6cdd8f;
          &::after {
            content: "";
            height: 2px;
            width: 32px;
            position: absolute;
            bottom: 0;
            left: calc((100% - 32px) / 2);
            background-color: #6cdd8f;
          }
        }
      }
    }
  }
  .search-box {
    padding: 20px;
    background: #fff;
    margin-top: 50px;
    .search-wrap {
      background: #f2f2f2;
      height: 32px;
      width: 100%;
      border-radius: 16px;
      padding: 0 20px;
      display: flex;
      align-items: center;
      img {
        height: 19px;
        width: 19px;
      }
      input {
        flex: 1;
        font-size: 12px;
        color: #333;
        background: unset;
        border: none;
        height: 100%;
        padding: 0 15px;
      }
    }
  }

  .works-list {
    flex: 1;
    overflow-y: scroll;
    .works-item {
      position: relative;
      height: 145px;
      width: 100%;
      padding: 15px 20px;
      display: flex;
      .works-img {
        width: 84px;
        height: 115px;
        border-radius: 10px;
        overflow: hidden;
        position: relative;
        background: #000;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          height: 100%;
        }
      }
      .works-infos {
        position: relative;
        flex: 1;
        margin-left: 8px;
        display: flex;
        flex-direction: column;
        .works-tit {
          position: relative;
          border-bottom: 1px solid #f9f9f9;
          height: 43px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          max-width: 240px;
          .tit-infos {
            * {
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
            }
            .works-title {
              font-size: 14px;
              font-weight: 700;
              color: #666;
            }

            .slogan {
              width: 100%;
              position: relative;
              div {
                font-size: 12px;
                margin: 5px 0;
                color: #999;
                line-height: 20px;
                max-width: 80%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              &::before {
                content: "";
                position: absolute;
                z-index: 1;
                height: 100%;
                width: 10px;
                display: block;
                background: url("../../assets/images/active/icon-right-arr.png");
                background-size: 10px 10px;
                background-position: center center;
                background-repeat: no-repeat;
                top: 0;
                right: 15px;
              }
            }
          }
        }
        .author-info {
          position: relative;
          display: flex;
          justify-content: space-between;
          .author {
            font-size: 12px;
            color: #666;
            max-width: 160px;
            p {
              max-width: 100%;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              line-height: 24px;
              &:first-child {
                color: #fedc01;
              }
            }
          }
          .remark-area {
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            .btn {
              width: 57px;
              height: 20px;
              border-radius: 5px;
              color: #fff;
              text-align: center;
              background: linear-gradient(90deg, #5dd682 0%, #5aff8e 100%);
              opacity: 1;
              border-radius: 11px;
              line-height: 21px;
            }
            .judge {
              display: flex;
              justify-content: flex-end;
              flex-direction: row-reverse;
              margin-top: 10px;
              img {
                width: 15px;
                height: 15px;
                border-radius: 50%;
              }
              i {
                font-size: 15px;
              }
            }
          }
        }
      }
    }
  }
  .student-list {
    flex: 1;
    overflow-y: scroll;
    .student-item {
      height: 67px;
      padding: 9.5px 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        height: 48px;
        width: 48px;
        border-radius: 24px;
      }
      .infos {
        flex: 1;
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
        text-align: left;
        div {
          font-size: 16px;
          line-height: 22px;
          color: #333;
        }
        p {
          line-height: 17px;
          color: #999;
          font-size: 12px;
        }
      }
      .school {
        font-size: 14px;
        color: #6cdd8f;
      }
    }
  }
}
</style>
<style lang="scss">
.search-page {
  .van-popup.slogan {
    border-radius: 20px 20px 0 0;
    overflow-y: hidden;
    .van-icon {
      right: calc((100% - 16px) / 2);
      font-size: 16px;
      &::after {
        content: "";
        position: absolute;
        left: -3px;
        top: -3px;
        height: 20px;
        width: 20px;
        box-sizing: content-box;
        border: 1px solid #c8c9cc;
        border-radius: 50%;
      }
    }
  }
  .info-wrap {
    margin-top: 50px;
    padding: 0 20px;
    height: 100%;
    overflow-y: scroll;
    .intro {
      margin-top: 20px;
      line-height: 24px;
      font-size: 14px;
      color: #999;
      padding-bottom: 80px;
    }
  }
}
</style>
